import { createApp } from "vue";

import "@/plugins/axios";

import PreApp from "./PreApp.vue";
import Maintenance from "@/views/Maintenance.vue";
import router from "./router";
import i18n from "./i18n";
import * as Sentry from "@sentry/browser";
import * as Integrations from "@sentry/integrations";
import store from "@/store";
import GAuth from "vue3-google-oauth2";

import { isMobile, isDemo } from "@/utils";

const maintenanceMode = false;

const gauthOption = {
    clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID,
    scope: "profile email",
    // prompt: "select_account",
    prompt: "consent",
    // eslint-disable-next-line @typescript-eslint/camelcase
    fetch_basic_profile: true
};

function setVhVar() {
    if (!window.innerHeight) {
        setTimeout(setVhVar, 500);
    } else {
        // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
        const vh = window.innerHeight * 0.01;
        // Then we set the value in the --vh custom property to the root of the document
        document.documentElement.style.setProperty("--vh", `${vh}px`);
    }
}
setVhVar();

// We listen to the resize event
window.addEventListener("resize", () => {
    // We execute the same script as before
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
});

if (!isMobile()) {
    document.body.classList.add("desktop");
}

if (maintenanceMode) {
    createApp(Maintenance).mount("#app");
} else {
    createApp(PreApp)
        .use(store)
        .use(router)
        .use(i18n)
        .use(GAuth, gauthOption)
        .mount("#app");
}

if (!isDemo()) {
    const dsn = "https://45ae1957797d4f58ab7d3cc99e8fc566@o462536.ingest.sentry.io/5592716";
    Sentry.init({
        dsn: dsn,
        integrations: [new Integrations.CaptureConsole({ levels: ["error"] })],
        environment: process.env.NODE_ENV
    });
}
